import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  draftCheckouts: [],
  publishedCheckouts: [],
  templates: [],
  checkoutData: null,
  managingPublication: false,
  needFeedback: false,
  hasFeedback: false,
  currentProductHotlinks: []
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
